import { render, staticRenderFns } from "./CreateProgram.vue?vue&type=template&id=52109dbe&scoped=true"
import script from "./CreateProgram.vue?vue&type=script&lang=js"
export * from "./CreateProgram.vue?vue&type=script&lang=js"
import style0 from "./CreateProgram.vue?vue&type=style&index=0&id=52109dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52109dbe",
  null
  
)

export default component.exports